import "./BackButton.scss";
import React, { useEffect, useState } from "react";

import back from "assets/img/back.png";
import backWhite from "assets/img/back-white.png";

export const BackButton = ({ onBack, darkMode }) => {
  const [isDarkMode, setIsDarkMode] = useState(false);

  useEffect(() => {
    if (
      window.matchMedia &&
      window.matchMedia("(prefers-color-scheme: dark)").matches &&
      darkMode
    ) {
      setIsDarkMode(true);
    }
  }, []);

  return (
    <div className="title-container">
      <div onClick={onBack}>
        <img src={isDarkMode ? backWhite : back} alt={"back"} />
      </div>
    </div>
  );
};
